// Teacher → one student's progress (the same advanced dashboard parents see).
// Gated server-side: the student must be in a class this teacher teaches. R9.

import { useT } from '@fajrarabi/i18n/react';
import { Card, CardBody, Skeleton } from '@fajrarabi/ui';
import { useQuery } from '@tanstack/react-query';
import { createFileRoute, useParams } from '@tanstack/react-router';

import { ProgressDashboard } from '~/components/progress/ProgressDashboard';
import { getStudentProgress } from '~/lib/school';

export const Route = createFileRoute('/$locale/teacher/student/$studentId')({
  component: StudentProgressScreen,
});

function StudentProgressScreen() {
  const t = useT();
  const { studentId } = useParams({ from: '/$locale/teacher/student/$studentId' });
  const query = useQuery({
    queryKey: ['teacher', 'student', studentId, 'progress'],
    queryFn: ({ signal }) => getStudentProgress(studentId, signal),
  });

  return (
    <div className="mx-auto max-w-3xl px-6 py-10">
      <h1 className="text-2xl font-bold text-ink-900">{t('app.teacher.view_progress')}</h1>
      <div className="mt-6">
        {query.isLoading ? (
          <Skeleton className="h-96 w-full" />
        ) : query.isError || !query.data ? (
          <Card>
            <CardBody>
              <p className="text-ink-700">{t('app.progress.empty_activity')}</p>
            </CardBody>
          </Card>
        ) : (
          <ProgressDashboard progress={query.data} />
        )}
      </div>
    </div>
  );
}
